import type {CardUser} from "@/components/cardUsers/scripts/types";
import {createEmptyCardUser} from "@/components/cardUsers/scripts/cardUserActions";

const selectCardUser = (users: CardUser[], userId: number) => {
  const fallbackUser = users.length > 0 ? users[0] : createEmptyCardUser();

  return users.find(user => user.id === userId) ?? fallbackUser;
};

export {
    selectCardUser
}
